var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.dataLoaded ? _c('div', {
    staticClass: "text-center"
  }, [_c('v-progress-circular', {
    staticClass: "mt-6",
    attrs: {
      "size": 50,
      "color": "primary",
      "indeterminate": ""
    }
  })], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dataLoaded,
      expression: "dataLoaded"
    }],
    staticClass: "mt-4"
  }, [_c('v-row', {
    staticClass: "my-0"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTable', {
    attrs: {
      "table-loading": _vm.tableLoading,
      "table-headers": _vm.tableHeaders,
      "table-items": _vm.notifications.list,
      "filter": "",
      "table-height": "370"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function fn() {
        return [_c('v-badge', {
          attrs: {
            "overlap": "",
            "dot": "",
            "value": !!_vm.checkProperty
          }
        }, [_c('v-btn', {
          staticClass: "white--text ml-4 filter-btn",
          attrs: {
            "small": "",
            "outlined": "",
            "rounded": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              _vm.showFilter = !_vm.showFilter;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-filter-outline")]), _c('span', {}, [_vm._v(_vm._s(_vm.showFilter ? 'Закрыть' : 'Фильтр'))])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "item.actions",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-icon', {
          staticClass: "mr-2 eye-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Просмотр"
          },
          on: {
            "click": function click($event) {
              return _vm.show(item);
            }
          }
        }, [_vm._v(" mdi-eye-outline ")])];
      }
    }])
  })], 1)], 1)], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('NotificationsFilters', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFilter,
      expression: "showFilter"
    }],
    attrs: {
      "notification-for-filter": _vm.notificationForFilter,
      "width-filter": "300",
      "top": "291",
      "right": "29"
    },
    on: {
      "applyFilter": _vm.applyFilter,
      "closeFilter": function closeFilter($event) {
        _vm.showFilter = false;
      }
    }
  })], 1), _c('UniversalConfirmDialog', {
    attrs: {
      "type": _vm.typeDialog,
      "selectedItem": _vm.selectedItem
    },
    on: {
      "closeDialog": _vm.closeDialog
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }